// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dk2x2i0 {
  font-family: var(--_18w76bw3n);
  display: block;
  width: 100%;
  appearance: none;
  user-select: none;
  border: 0;
  margin: 0;
  border-radius: var(--_18w76bw4t);
  transition: all 200ms;
  color: var(--_18w76bw2g);
  resize: vertical;
  overflow: auto;
}
.dk2x2i1 {
  border: var(--_18w76bw4q);
  border-color: var(--_18w76bw37);
  background-color: var(--_18w76bw26);
}
.dk2x2i1:not([disabled]):hover {
  border-color: var(--_18w76bw2g);
}
.dk2x2i1:not([disabled]):focus {
  border-color: var(--_18w76bw2g);
  box-shadow: none;
  outline: none;
}
.dk2x2i2:focus {
  box-shadow: none;
  outline: none;
}
.dk2x2i3 {
  color: white;
  border-color: rgba(255, 255, 255, 0.5);
}
.dk2x2i3::placeholder {
  color: white;
}
.dk2x2i4 {
  padding-top: var(--_18w76bwc);
  padding-bottom: var(--_18w76bwc);
  height: var(--_18w76bww);
  font-size: var(--_18w76bw3r);
}
.dk2x2i5 {
  font-size: var(--_18w76bw3r);
  height: 125px;
  padding-top: var(--_18w76bwc);
  padding-bottom: var(--_18w76bwc);
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwe);
}
.dk2x2i9:focus {
  outline: none;
}
.dk2x2i9:focus-visible {
  outline: none;
}
.dk2x2ia {
  border-color: var(--_18w76bw3k) !important;
}
.dk2x2ia:hover {
  border-color: var(--_18w76bw3k);
}
.dk2x2ia:focus {
  border-color: var(--_18w76bw2g);
}
.dk2x2ib {
  border-color: var(--_18w76bw31) !important;
}
.dk2x2ic {
  position: absolute;
  pointer-events: none;
  width: calc(100% - 10px);
  white-space: nowrap;
  color: var(--_18w76bw2f);
  letter-spacing: var(--_18w76bw4d);
  overflow: hidden;
  transition: all .15s cubic-bezier(0,1,0,1);
}
.dk2x2if {
  color: white;
  border-color: rgba(255, 255, 255, 0.5);
}
.dk2x2if::placeholder {
  color: white;
}
.dk2x2ig {
  height: var(--_18w76bwm);
  font-size: var(--_18w76bw3r);
  padding-left: 10px;
  line-height: normal;
  padding-right: 10px;
}
.dk2x2ih {
  font-size: var(--_18w76bw3s);
  height: var(--_18w76bwo);
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwe);
}
.dk2x2il {
  width: auto;
  height: 3px;
  top: -2px;
  padding-left: 5px;
  line-height: 0;
  overflow: visible;
  font-size: var(--_18w76bw3q);
}
.dk2x2im:focus {
  outline: none;
}
.dk2x2im:focus-visible {
  outline: none;
}
input:focused + .dk2x2in {
  color: var(--_18w76bw3k);
}
.dk2x2io {
  color: var(--_18w76bw31);
}
.dk2x2iq {
  height: 3px;
}
.dk2x2ir {
  color: var(--_18w76bw3k);
}
.dk2x2is {
  padding-left: var(--_18w76bwm);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,gCAAgC;EAChC,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".dk2x2i0 {\n  font-family: var(--_18w76bw3n);\n  display: block;\n  width: 100%;\n  appearance: none;\n  user-select: none;\n  border: 0;\n  margin: 0;\n  border-radius: var(--_18w76bw4t);\n  transition: all 200ms;\n  color: var(--_18w76bw2g);\n  resize: vertical;\n  overflow: auto;\n}\n.dk2x2i1 {\n  border: var(--_18w76bw4q);\n  border-color: var(--_18w76bw37);\n  background-color: var(--_18w76bw26);\n}\n.dk2x2i1:not([disabled]):hover {\n  border-color: var(--_18w76bw2g);\n}\n.dk2x2i1:not([disabled]):focus {\n  border-color: var(--_18w76bw2g);\n  box-shadow: none;\n  outline: none;\n}\n.dk2x2i2:focus {\n  box-shadow: none;\n  outline: none;\n}\n.dk2x2i3 {\n  color: white;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n.dk2x2i3::placeholder {\n  color: white;\n}\n.dk2x2i4 {\n  padding-top: var(--_18w76bwc);\n  padding-bottom: var(--_18w76bwc);\n  height: var(--_18w76bww);\n  font-size: var(--_18w76bw3r);\n}\n.dk2x2i5 {\n  font-size: var(--_18w76bw3r);\n  height: 125px;\n  padding-top: var(--_18w76bwc);\n  padding-bottom: var(--_18w76bwc);\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwe);\n}\n.dk2x2i9:focus {\n  outline: none;\n}\n.dk2x2i9:focus-visible {\n  outline: none;\n}\n.dk2x2ia {\n  border-color: var(--_18w76bw3k) !important;\n}\n.dk2x2ia:hover {\n  border-color: var(--_18w76bw3k);\n}\n.dk2x2ia:focus {\n  border-color: var(--_18w76bw2g);\n}\n.dk2x2ib {\n  border-color: var(--_18w76bw31) !important;\n}\n.dk2x2ic {\n  position: absolute;\n  pointer-events: none;\n  width: calc(100% - 10px);\n  white-space: nowrap;\n  color: var(--_18w76bw2f);\n  letter-spacing: var(--_18w76bw4d);\n  overflow: hidden;\n  transition: all .15s cubic-bezier(0,1,0,1);\n}\n.dk2x2if {\n  color: white;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n.dk2x2if::placeholder {\n  color: white;\n}\n.dk2x2ig {\n  height: var(--_18w76bwm);\n  font-size: var(--_18w76bw3r);\n  padding-left: 10px;\n  line-height: normal;\n  padding-right: 10px;\n}\n.dk2x2ih {\n  font-size: var(--_18w76bw3s);\n  height: var(--_18w76bwo);\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwe);\n}\n.dk2x2il {\n  width: auto;\n  height: 3px;\n  top: -2px;\n  padding-left: 5px;\n  line-height: 0;\n  overflow: visible;\n  font-size: var(--_18w76bw3q);\n}\n.dk2x2im:focus {\n  outline: none;\n}\n.dk2x2im:focus-visible {\n  outline: none;\n}\ninput:focused + .dk2x2in {\n  color: var(--_18w76bw3k);\n}\n.dk2x2io {\n  color: var(--_18w76bw31);\n}\n.dk2x2iq {\n  height: 3px;\n}\n.dk2x2ir {\n  color: var(--_18w76bw3k);\n}\n.dk2x2is {\n  padding-left: var(--_18w76bwm);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
